import { render, staticRenderFns } from "./HistoricoProcessoConversa.vue?vue&type=template&id=e349853e&scoped=true"
import script from "./HistoricoProcessoConversa.vue?vue&type=script&lang=js"
export * from "./HistoricoProcessoConversa.vue?vue&type=script&lang=js"
import style0 from "./HistoricoProcessoConversa.vue?vue&type=style&index=0&id=e349853e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e349853e",
  null
  
)

export default component.exports